import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Header, Sidebar } from '~/components';
import { PortalRoutes } from './routes';
import { DialogProvider } from '~/contexts';
import { AnnouncementControl } from '~/pages/Portal/Admin/Announcements/AnnoucementControl';
import { PrivacyPolicyControl } from '~/pages/Portal/Admin/PrivacyPolicy/PrivacyPolicyControl';
import { PrivacyPolicyFooter } from '~/components/PrivacyPolicyFooter';
import { DownloadControl } from '~/pages/Portal/Documents/DownloadControl';
import { FeatureFlagsProvider } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';

export const Portal: React.VFC = () => {
  return (
    <FeatureFlagsProvider>
      <Flex h="100vh" flexDir="column" overflow="hidden">
        <Header />
        <Flex h="100%" overflow="hidden">
          <Sidebar />
          <Flex
            w="100%"
            sx={{ overflowY: 'scroll', height: 'calc(100vh - 59px)' }}
          >
            <Flex flexDir="column" w="100%" justifyContent="space-between">
              <DialogProvider>
                <PortalRoutes />
              </DialogProvider>
              <AnnouncementControl />
              <DownloadControl />
              <PrivacyPolicyControl />
              <PrivacyPolicyFooter />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </FeatureFlagsProvider>
  );
};
